import lang from './locales/tarteaucitronjs/tarteaucitron.fr';

let isTarteAuCitronInitialized = false;

function patchTarteAuCitronAlertScroll(tarteaucitron) {
  const ui = tarteaucitron.userInterface;

  if (!ui || ui.openAlert.__lgfScrollPatched) {
    return;
  }

  const originalOpenAlert = ui.openAlert.bind(ui);

  ui.openAlert = function () {
    const { scrollX, scrollY } = window;
    const alert = document.getElementById('tarteaucitronAlertBig');

    if (alert) {
      alert.classList.remove('hidden');
    }

    originalOpenAlert();

    requestAnimationFrame(() => {
      window.scrollTo({
        left: scrollX,
        top: scrollY,
        behavior: 'instant',
      });
    });
  };

  ui.openAlert.__lgfScrollPatched = true;
}

function patchTarteAuCitronOpenPanel(tarteaucitron) {
  const ui = tarteaucitron.userInterface;

  if (!ui || ui.openPanel.__lgfOpenPanelPatched) {
    return;
  }

  const originalOpenPanel = ui.openPanel.bind(ui);

  ui.openPanel = function () {
    const root = document.getElementById('tarteaucitronRoot');

    if (root?.classList.contains('tarteaucitronBeforeVisible')) {
      ui.closeAlert();
    }

    originalOpenPanel();
  };

  ui.openPanel.__lgfOpenPanelPatched = true;
}

function patchTarteAuCitronRespondAll(tarteaucitron) {
  const ui = tarteaucitron.userInterface;

  if (!ui || ui.respondAll.__lgfPatched) {
    return;
  }

  const originalRespondAll = ui.respondAll.bind(ui);

  ui.respondAll = function (status, type, allowSafeAnalytics) {
    const s = tarteaucitron.services;

    for (const jobKey of tarteaucitron.job) {
      const service = s[jobKey];

      if (type !== undefined && type !== '' && service.type !== type) {
        continue;
      }

      if (allowSafeAnalytics && service.safeanalytic === true) {
        continue;
      }

      const itemStatusElem = document.getElementById(
        'tacCurrentStatus' + service.key
      );

      if (!itemStatusElem) {
        const line = document.getElementById(service.key + 'Line');

        if (line) {
          const statusSpan = document.createElement('span');
          statusSpan.className = 'tacCurrentStatus';
          statusSpan.id = 'tacCurrentStatus' + service.key;
          statusSpan.style.display = 'none';
          line.appendChild(statusSpan);
        }
      }
    }

    try {
      originalRespondAll(status, type, allowSafeAnalytics);
    } catch (error) {
      console.error('tarteaucitron respondAll failed', error);
    }

    const root = document.getElementById('tarteaucitronRoot');

    if (!type && root?.classList.contains('tarteaucitronBeforeVisible')) {
      ui.closeAlert();
    }
  };

  ui.respondAll.__lgfPatched = true;
}

export function initTarteAuCitron() {
  const tarteaucitron = window.tarteaucitron;

  if (!tarteaucitron) {
    return;
  }

  if (isTarteAuCitronInitialized) {
    return;
  }

  isTarteAuCitronInitialized = true;

  tarteaucitron.lang = lang;

  // facebook pixel
  tarteaucitron.services.fake_facebookpixel = {
    key: 'fake_facebookpixel',
    type: 'ads',
    name: 'Facebook Pixel',
    uri: 'https://fr-fr.facebook.com/business/help/www/651294705016616',
    needConsent: true,
    cookies: [
      'datr',
      'fr',
      'reg_ext_ref',
      'reg_fb_gate',
      'reg_fb_ref',
      'sb',
      'wd',
      'x-src',
    ],
    js: function () {
      window.dataLayer.push({
        event: 'gdprConsentUpdate',
        gdpr: {
          fbkpixelConsent: true,
        },
      });
    },
  };

  // google analytics
  tarteaucitron.services.fake_analytics = {
    key: 'fake_analytics',
    type: 'analytic',
    name: 'Google Analytics (GA4)',
    uri: 'https://policies.google.com/privacy',
    needConsent: true,
    cookies: [
      '_ga',
      '_gat',
      '_gid',
      '__utma',
      '__utmb',
      '__utmc',
      '__utmt',
      '__utmz',
      '_gat_gtag_',
      '_ga_',
      '_gcl_au',
    ],
    js: function () {
      window.dataLayer.push({
        event: 'gdprConsentUpdate',
        gdpr: {
          analyticsConsent: true,
        },
      });
    },
  };

  // Google Adwords
  tarteaucitron.services.fake_googleadwordsremarketing = {
    key: 'fake_googleadwordsremarketing',
    type: 'ads',
    name: 'Google Adwords (remarketing)',
    uri: 'https://www.google.com/settings/ads',
    needConsent: true,
    cookies: [],
    js: function js() {
      window.dataLayer.push({
        event: 'gdprConsentUpdate',
        gdpr: {
          adwordsConsent: true,
        },
      });
    },
  };

  // Clarity
  tarteaucitron.services.fake_clarity = {
    key: 'fake_clarity',
    type: 'analytic',
    name: 'Clarity',
    uri: 'https://clarity.microsoft.com/privacy',
    needConsent: true,
    cookies: [],
    js: function js() {
      window.dataLayer.push({
        event: 'gdprConsentUpdate',
        gdpr: {
          clarityConsent: true,
        },
      });
    },
  };

  // Pinterest
  tarteaucitron.services.fake_pinterest = {
    key: 'fake_pinterest',
    type: 'social',
    name: 'Pinterest',
    uri: 'https://about.pinterest.com/privacy-policy',
    needConsent: true,
    cookies: [],
    js: function () {
      window.dataLayer.push({
        event: 'gdprConsentUpdate',
        gdpr: {
          pinterestConsent: true,
        },
      });
    },
  };

  // Pinterest
  tarteaucitron.services.fake_tiktok = {
    key: 'fake_tiktok',
    type: 'social',
    name: 'TikTok',
    uri: 'https://www.tiktok.com/legal/privacy-policy-eea',
    needConsent: true,
    cookies: [],
    js: function () {
      window.dataLayer.push({
        event: 'gdprConsentUpdate',
        gdpr: {
          tiktokConsent: true,
        },
      });
    },
  };

  // doubleclick
  tarteaucitron.services.fake_doubleclick = {
    key: 'fake_doubleclick',
    type: 'ads',
    name: 'Google Marketing Platform',
    uri: 'https://support.google.com/admanager/answer/2839090',
    needConsent: true,
    cookies: [],
    js: function () {
      window.dataLayer.push({
        event: 'gdprConsentUpdate',
        gdpr: {
          dbclickConsent: true,
        },
      });
    },
  };

  tarteaucitron.services.klaviyo = {
    key: 'klaviyo',
    type: 'ads',
    name: 'Klaviyo',
    uri: 'https://help.klaviyo.com/hc/en-us/articles/360034666712-About-Cookies-in-Klaviyo',
    needConsent: true,
    cookies: ['__kla_id'],
    js: function () {
      'use strict';
      const companyId = process.env.MIX_KLAVIYO_SCRIPT_ID;
      if (companyId === undefined) {
        return;
      }
      tarteaucitron.addScript(
        `//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${companyId}`
      );
    },
  };

  tarteaucitron.init({
    showIcon: false,
    privacyUrl: '' /* Privacy policy url */,

    hashtag: '#tarteaucitron' /* Open the panel with this hashtag */,
    cookieName: 'tarteaucitronv2' /* Cookie name */,

    orientation: 'middle' /* Banner position (top - bottom) */,
    bodyPosition:
      'top' /* Prepend #tarteaucitronRoot — avoids focus() scrolling to page bottom */,
    showAlertSmall: false /* Show the small banner on bottom right */,
    cookieslist: true /* Show the cookie list */,
    adblocker: false /* Show a Warning if an adblocker is detected */,
    AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
    highPrivacy: true /* Disable auto consent */,
    handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

    removeCredit: true /* Remove credit link */,
    moreInfoLink: true /* Show more info link */,
    useExternalCss: true /* If false, the tarteaucitron.css file will be loaded */,
    useExternalJs: true /* If false, the tarteaucitron.services.js file will be loaded */,

    //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for subdomain website */

    readmoreLink:
      '/terms-of-use' /* Change the default readmore link pointing to opt-out.ferank.eu */,
  });

  patchTarteAuCitronAlertScroll(tarteaucitron);
  patchTarteAuCitronOpenPanel(tarteaucitron);
  patchTarteAuCitronRespondAll(tarteaucitron);

  const gtmMore = function () {
    window.addEventListener('lgf.addToCart', function (e) {
      window.dataLayer.push({
        event: 'LGF--addToCart',
        cart: e.detail.cart,
      });
    });

    window.addEventListener('lgf.initiateOrderPayment', function (e) {
      window.dataLayer.push({
        event: 'LGF--initiateOrderPayment',
        cart: e.detail.cart,
      });
    });

    window.addEventListener('lgf.orderPlaced', function (e) {
      window.dataLayer.push({
        event: 'LGF--purchase',
        order: e.detail.order,
      });
    });

    window.addEventListener('lgf.applyCoupon', function (e) {
      window.dataLayer.push({
        event: 'LGF--applyCoupon',
        coupon: e.detail.coupon,
      });
    });

    const scrollThresholds = [25, 50, 75, 100];
    let cachedScrollHeight = null;
    let cachedOffsetHeight = null;
    let scrollData = [];

    const updateScrollData = function () {
      cachedScrollHeight = document.body.scrollHeight;
      cachedOffsetHeight = document.body.offsetHeight;

      scrollData = scrollThresholds.map(function (threshold) {
        return {
          percent: threshold,
          depth: (threshold * cachedScrollHeight) / 100,
        };
      });
    };

    if (document.readyState === 'complete') {
      updateScrollData();
    } else {
      window.addEventListener('load', updateScrollData, { once: true });
    }

    let resizeTimeout;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateScrollData, 200);
      },
      { passive: true }
    );

    const processScrollEvent = function () {
      let scrollTop = document.body.scrollTop + cachedOffsetHeight;

      for (let i = scrollData.length - 1; i >= 0; i--) {
        const threshold = scrollData[i];
        if (threshold.depth <= scrollTop) {
          scrollData.splice(i, 1); // Remove element to improve performances
          window.dataLayer.push({
            event: 'LGF--pageScroll',
            threshold: threshold.percent,
          });
        }
      }

      scrollTimeout = undefined;
    };

    let scrollTimeout = undefined;
    document.body.addEventListener(
      'scroll',
      function () {
        if (undefined === scrollTimeout) {
          scrollTimeout = setTimeout(processScrollEvent, 200);
        }
      },
      { passive: true }
    );
  };

  // Init consent state
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'gdprConsentUpdate',
    gdpr: {
      fbkpixelConsent: false,
      analyticsConsent: false,
      adwordsConsent: false,
      pinterestConsent: false,
      tiktokConsent: false,
      dbclickConsent: false,
    },
  });

  gtmMore();

  tarteaucitron.job = tarteaucitron.job || [];
  tarteaucitron.job.push('fake_facebookpixel');
  tarteaucitron.job.push('fake_analytics');
  tarteaucitron.job.push('fake_clarity');
  tarteaucitron.job.push('fake_googleadwordsremarketing');
  tarteaucitron.job.push('fake_pinterest');
  tarteaucitron.job.push('fake_tiktok');
  tarteaucitron.job.push('fake_doubleclick');
  tarteaucitron.job.push('klaviyo');

  window.tartaucitron = tarteaucitron;
}

window.__initTarteAuCitron = window.__initTarteAuCitron || initTarteAuCitron;

if (window.tarteaucitron) {
  initTarteAuCitron();
}

window.addEventListener('lgf.tac-open', function () {
  const openPanel = () => {
    if (window.tarteaucitron?.userInterface) {
      window.tarteaucitron.userInterface.openPanel();
    }
  };

  if (window.__loadTarteAuCitron) {
    const loadResult = window.__loadTarteAuCitron();

    if (loadResult && typeof loadResult.then === 'function') {
      loadResult.then(openPanel);

      return;
    }
  }

  openPanel();
});
